import React from 'react';
import ReportingBookingContactsPage from '../components/ReportingBookingContactsPage';

const ReportingBookingContactsApp = (props) => (
  <ReportingBookingContactsPage {...props} />
);

export default ReportingBookingContactsApp;
